'use strict';
window.theme = window.theme || {};

theme.AgeGate = function () {
  function AgeGate() {
    this.Selector = {
      js_age_gate_container: document.querySelector('.js-age-gate'),
      js_age_gate_bg: document.querySelector('.js-age-gate-bg'),
      js_cookies_no_day: document.querySelector('[js-cookies-day]'),
      js_initial_screen: document.querySelector('.js-age-gate__content'),
      js_body: document.querySelector('body'),
      year_input: document.querySelectorAll(
        '.js-age-gate__dateyear .age-gate__input input'
      ),
      birth_year_title: document.querySelector('.js-age-gate-subtitle'),
      year_selected: document.querySelector('.js-age-gate__dateyear'),
      age_gate_location: document.querySelector('.js-age-gate__location'),
      age_gate_inner: document.querySelector('.js-age-gate__inner'),
      age_gate_change_text: document.querySelector(
        '.js-age-gate__country-change'
      ),
      newsletter_popup:  document.querySelector('.js-newsletter-modal'),
      subscribeContent:  document.querySelector('.js-news-letter-modal__subscribe'),
      newsLetterForm:  document.querySelector('.js-newsletter-modal__form'),
      fieldButton: document.querySelector('.newsletter-field__button'),
    };

    this.scrollChecker = {
      js_url: window.location.hash,
      js_id_tag: '#reveal-your-recipe-section',
    };
   
    this.Button = {
      country_list: document.querySelectorAll('ul.age-gate-country-list > li'),
      country_list_btn: document.querySelectorAll(
        'ul.js-age-gate-country-list > li > a > button'
      ),
      country_list_menu: document.querySelector('.js-age-gate-country-list'),
      birth_year_btn: document.querySelector('.js-age-gate__content > button'),
      choose_country: document.querySelector('.js-age-gate__country-btn'),
      choose_country_strong: document.querySelector(
        '.js-age-gate__country-btn span > strong'
      ),
      age_gate_location_close: document.querySelector(
        '.js-age-gate__location-close'
      ),
    };

    if (this.Selector.js_age_gate_container && this.getCookie() === 'on') {
      dataLayer.push({ event: 'age_gate_display' });
      this.load();
    } else {
      this.Selector.js_age_gate_container.classList.remove('is-show');
      this.Selector.js_age_gate_container.classList.add('is-hide');
      this.Selector.js_age_gate_bg.classList.add('is-hide');
      this.Selector.js_body.classList.remove('disabled-scrollbar');
      this.Selector.js_age_gate_bg.classList.add('disabled');
    }
  }

  AgeGate.prototype.newsLetterTimein = function () {
    var _ = this;
    let timeout = setTimeout(function() {
      _.Selector.newsletter_popup.style.display = 'block';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      localStorage.setItem('popup', 'off');
      _.Selector.subscribeContent.classList.remove('is-hidden');
      _.Selector.newsLetterForm.classList.remove('is-shown');
      document.body.style.position = '';
    }, 15000);

    _.Selector.fieldButton.addEventListener('click', function() {
      clearTimeout(timeout);
      localStorage.setItem('popup', 'off');
    });
  }

  AgeGate.prototype.load = function () {
    var _ = this;
    var today = new Date();
    _.Selector.js_age_gate_container.classList.add('is-show');
    _.Selector.js_body.classList.add('disabled-scrollbar');
    _.Selector.js_age_gate_bg.classList.remove('disabled');
    
    _.Button.country_list.forEach((el) => {
      el.addEventListener('click', (e) => {
        _.Button.country_list.forEach((btn) => {
          btn.classList.remove('selected');
        });

        let el = e.target;

        if (e.target.tagName.toLowerCase() !== 'li') {
          el = e.target.closest('li');
        }

        el.classList.add('selected');

        _.Button.choose_country_strong.textContent = el.dataset.country;

        _.Selector.age_gate_inner.classList.remove('is-hide');
        _.Selector.age_gate_location.classList.add('is-hide');

        const link_uk = document.querySelectorAll('.age-gate__tcp-text.js-age-gate__tcp-text__uk a');
        const link_row = document.querySelectorAll('.age-gate__tcp-text.js-age-gate__tcp-text__row a');

        if (el.classList.contains('selected') && el.dataset.country === 'United Kingdom') {
          link_uk[0].setAttribute('href', 'https://uk.bruichladdich.com/pages/terms-of-use');
          link_uk[1].setAttribute('href', 'https://uk.bruichladdich.com/pages/privacy-policy');
          link_row[0].setAttribute('href', 'https://uk.bruichladdich.com/pages/terms-of-use');
          link_row[1].setAttribute('href', 'https://uk.bruichladdich.com/pages/privacy-policy');
        } else {
          link_uk[0].setAttribute('href', 'https://www.bruichladdich.com/pages/terms-of-use');
          link_uk[1].setAttribute('href', 'https://www.bruichladdich.com/pages/privacy-policy');
          link_row[0].setAttribute('href', 'https://www.bruichladdich.com/pages/terms-of-use');
          link_row[1].setAttribute('href', 'https://www.bruichladdich.com/pages/privacy-policy');
        }
      });

      _.location();
    });
    document.addEventListener('DOMContentLoaded', function () {
      // const url = window.location.hash;
      // const idTag = '#reveal-your-recipe-section';
      
      const body = document.querySelector("body");

      _.Selector.year_input[0].addEventListener('keyup', (event) => {
        if (event.target.value.length == 4) {
          if (
            _.Selector.year_selected.classList.contains('is-month-day-enabled')
          ) {
            if (
              _.Selector.year_input[1].value.length > 1 &&
              _.Selector.year_input[2].value.length > 1
            ) {
              _.calculate(0);
            }
          } else {
            _.calculate(3);
          }
        }
      });
      _.Selector.year_input[1].addEventListener('keyup', (event) => {
        if (event.target.value.length == 2) {
          if (
            _.Selector.year_selected.classList.contains('is-month-day-enabled')
          ) {
            if (
              _.Selector.year_input[0].value.length == 4 &&
              _.Selector.year_input[2].value.length > 2
            ) {
              _.calculate(0);
            }
          } else {
            _.calculate(1);
          }
        }
      });
      _.Selector.year_input[2].addEventListener('keyup', (event) => {
        if (event.target.value.length == 2) {
          if (
            _.Selector.year_selected.classList.contains('is-month-day-enabled')
          ) {
            if (
              _.Selector.year_input[0].value.length == 4 &&
              _.Selector.year_input[1].value.length > 1
            ) {
              _.calculate(0);
            }
          } else {
            _.calculate(2);
          }
        }
      });
      _.Selector.year_input[0].focus();
      _.Selector.year_input[0].setAttribute('max', today.getFullYear());
      _.Selector.year_input[0].setAttribute(
        'min',
        Number(today.getFullYear()) - 200
      );
      _.Selector.year_input[1].setAttribute('min', 1);
      _.Selector.year_input[1].setAttribute('max', 12);
      _.Selector.year_input[2].setAttribute('min', 1);
      _.Selector.year_input[2].setAttribute('max', 31);
      _.Selector.js_age_gate_bg.classList.add('disabled'); 


    });

    _.Selector.birth_year_title.textContent =
      _.Selector.birth_year_title.getAttribute('data-year-text');
    _.Button.birth_year_btn.addEventListener('click', () => {
      _.Selector.birth_year_title.textContent =
        _.Selector.birth_year_title.getAttribute('data-year-text');
      _.Button.birth_year_btn.classList.add('is-hide');
      _.Selector.year_selected.classList.remove('is-hide');
      _.Selector.year_input[0]
        .closest('.age-gate__input')
        .classList.remove('is-hide');
      _.Selector.year_input[0].value = '';
      _.Selector.year_input[1].value = '';
      _.Selector.year_input[2].value = '';
      _.Selector.year_input[0].focus();
      _.toggleMonthDay();
    });

    _.Selector.year_input[1].addEventListener('focus', (event) => {
      if (_.Selector.year_selected.classList.contains('is-month-day-enabled')) {
        event.target.type = 'text';
        event.target.setSelectionRange(
          event.target.value.length - 1,
          event.target.value.length
        );
        event.target.type = 'number';
      }
    });
    _.Selector.year_input[1].addEventListener('keydown', (event) => {
      if (
        _.Selector.year_selected.classList.contains('is-month-day-enabled') &&
        event.keyCode == 8 &&
        event.target.value.length == 0
      ) {
        _.Selector.year_input[0].focus();
      }
    });
    _.Selector.year_input[1].addEventListener('keyup', (event) => {
      if (_.Selector.year_selected.classList.contains('is-month-day-enabled')) {
        if (event.target.value.length == 2) {
          _.Selector.year_input[2].focus();
        }
        if (event.keyCode == 37) {
          _.Selector.year_input[0].focus();
        }
        if (event.keyCode == 39) {
          _.Selector.year_input[2].focus();
        }
        if (event.target.value > 12) {
          event.target.value = 12;
        }
        if (event.target.value === '00') {
          event.target.value = '01';
        }
      }
    });
    _.Selector.year_input[2].addEventListener('keydown', (event) => {
      if (
        _.Selector.year_selected.classList.contains('is-month-day-enabled') &&
        event.keyCode == 8 &&
        event.target.value.length == 0
      ) {
        _.Selector.year_input[1].focus();
      }
    });
    _.Selector.year_input[2].addEventListener('keyup', (event) => {
      if (_.Selector.year_selected.classList.contains('is-month-day-enabled')) {
        if (event.keyCode == 37) {
          _.Selector.year_input[1].focus();
        }
        if (event.target.value > 31) {
          event.target.value = 31;
        }
        if (event.target.value.length == 2) {
          event.target.blur();
        }
        if (event.target.value === '00') {
          event.target.value = '01';
        }
      }
    });
    _.Selector.year_input[0].addEventListener('keyup', (event) => {
      if (_.Selector.year_selected.classList.contains('is-month-day-enabled')) {
        if (event.target.value.length == 4) {
          _.Selector.year_input[1].focus();
        }
        if (event.keyCode == 39) {
          _.Selector.year_input[1].focus();
        }
      }
    });
    _.Selector.year_input[0].addEventListener('focus', (event) => {
      if (_.Selector.year_selected.classList.contains('is-month-day-enabled')) {
        event.target.type = 'text';
        event.target.setSelectionRange(
          event.target.value.length - 1,
          event.target.value.length
        );
        event.target.type = 'number';
      }
    });

    _.Button.choose_country.addEventListener('click', (e) => {
      e.preventDefault();
      _.Selector.age_gate_inner.classList.add('is-hide');
      _.Selector.age_gate_location.classList.remove('is-hide');
    });

    _.Button.age_gate_location_close.addEventListener('click', (e) => {
      e.preventDefault();
      _.Selector.age_gate_inner.classList.remove('is-hide');
      _.Selector.age_gate_location.classList.add('is-hide');
    });

    _.Button.choose_country.addEventListener('mouseover', (e) => {
      e.preventDefault();
      // e.target.innerHTML = '[Change?]';
      _.Selector.age_gate_change_text.innerHTML = '[Change?]';
    });

    _.Button.choose_country.addEventListener('mouseout', (e) => {
      e.preventDefault();
      // e.target.innerHTML = document.querySelector('.age-gate__country-lang').textContent;
      _.Selector.age_gate_change_text.innerHTML = document.querySelector(
        '.age-gate__country-lang'
      ).textContent;
    });

    /* hide age gate in privacy policy and terms page */
    let title_page = document.querySelector(
      '.section-header__title'
    ).textContent;

    //console.log(title_page);
    if (title_page == 'Privacy Policy' || title_page == 'Terms of Use') {
      document.querySelector('.age-gate').classList.remove('is-show');
      document.querySelector('body').classList.remove('disabled-scrollbar');
    }

    /* get user location */
    _.location();
    
  };

  AgeGate.prototype.confirm = function () {
    var _ = this;

    dataLayer.push({ event: 'age_gate_validation' });

    let country = '';
    _.Button.country_list.forEach((c) => {
      if (c.classList.contains('selected')) {
        country = c.dataset.country;
      }
    });

    if (country !== 'United Kingdom') {
      _.setCookie();
      _.Selector.js_age_gate_container.classList.remove('is-show');
      _.Selector.js_body.classList.remove('disabled-scrollbar');
      _.Selector.js_age_gate_bg.classList.add('disabled');
    } else {
      _.setCookie('bruichladdich.com');
      window.location.href = 'https://uk.bruichladdich.com/';
    }
   
    setTimeout(() => {
      if (_.scrollChecker.js_url === _.scrollChecker.js_id_tag) {
        const container = document.querySelector("#reveal-your-recipe-section");
        const distanceToTop = container.getBoundingClientRect().top;  
        document.body.style.top = '';
        window.scrollTo(0, distanceToTop - 71);
      } 
    },300);
    
     _.newsLetterTimein();
  };

  AgeGate.prototype.prohibited = function () {
    var _ = this;
    _.Selector.birth_year_title.textContent =
      _.Selector.birth_year_title.getAttribute('data-warning-text');
    _.Button.birth_year_btn.classList.remove('is-hide');
    _.Selector.year_input[0]
      .closest('.age-gate__input')
      .classList.add('is-hide');
    _.Selector.year_input[1]
      .closest('.age-gate__input')
      .classList.add('is-hide');
    _.Selector.year_input[2]
      .closest('.age-gate__input')
      .classList.add('is-hide');
    _.Selector.year_selected.classList.add('is-hide');
  };

  AgeGate.prototype.prohibited_old = function () {
    var _ = this;
    _.Selector.birth_year_title.textContent = 'SORRY, INVALID ENTERED YEAR';
    _.Button.birth_year_btn.classList.remove('is-hide');
    _.Selector.year_input[0]
      .closest('.age-gate__input')
      .classList.add('is-hide');
    _.Selector.year_input[1]
      .closest('.age-gate__input')
      .classList.add('is-hide');
    _.Selector.year_input[2]
      .closest('.age-gate__input')
      .classList.add('is-hide');
    _.Selector.year_selected.classList.add('is-hide');
  };

  AgeGate.prototype.setCookie = function (domain = null) {
    var _ = this;
    let noday = _.Selector.js_cookies_no_day.getAttribute('js-cookies-day');
    if (isNaN(noday)) {
      noday = 365;
    } else {
      noday = Number(noday);
    }
    const d = new Date();
    d.setTime(d.getTime() + noday * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    // document.cookie = 'age_gate=off;' + expires + ';path=/';
    if (domain != null) {
      document.cookie =
        'age_gate=off;' + expires + ';path=/' + ';domain=bruichladdich.com';
    } else {
      document.cookie = 'age_gate=off;' + expires + ';path=/';
    }
  };

  AgeGate.prototype.getCookie = function () {
    let name = 'age_gate=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return 'on';
  };

  AgeGate.prototype.calculate = function (input_index) {
    var _ = this;
    const d = new Date();
    let current_year = d.getFullYear();
    let current_month = Number(d.getMonth()) + 1;
    let current_day = Number(d.getDate());
    let legal_age = 0;

    _.Button.country_list.forEach((el) => {
      var user_country = new RegExp(
        _.Selector.js_age_gate_container.getAttribute('data-user-country')
      );
      if (el.classList.contains('selected')) {
        legal_age = Number(el.getAttribute('data-legal-age'));
      }

      if (user_country.test('United States')) {
        legal_age = 21;
      }
    });

    switch (input_index) {
      case 0:
        var birthdate = new Date(
          _.Selector.year_input[1].value +
            '/' +
            _.Selector.year_input[2].value +
            '/' +
            _.Selector.year_input[0].value
        );
        birthdate.setDate(birthdate.getDate() + 1);
        var ageDifMs = Date.now() - birthdate.getTime();
        var ageDate = new Date(ageDifMs);
        var actualAge = Math.abs(ageDate.getUTCFullYear() - 1970);
      
        if (actualAge >= legal_age && Number(_.Selector.year_input[0].value) <= current_year) {
          if (actualAge < Number(101)) {
            _.confirm();  
          } else {
            _.prohibited_old();
          }
        } else {
          _.prohibited();
        }
        break;
      case 1:
        // month
        if (Number(_.Selector.year_input[1].value) < Number(current_month)) {
          _.confirm();
        }
        if (Number(_.Selector.year_input[1].value) == Number(current_month)) {
          _.Selector.birth_year_title.textContent =
            _.Selector.birth_year_title.getAttribute('data-day-text');
          _.Selector.year_input[1]
            .closest('.age-gate__input')
            .classList.add('is-hide');
          _.Selector.year_input[2]
            .closest('.age-gate__input')
            .classList.remove('is-hide');
          _.Selector.year_input[2].focus();
        }
        if (Number(_.Selector.year_input[1].value) > Number(current_month)) {
          _.prohibited();
        }
        break;
      case 2:
        // day
        if (Number(_.Selector.year_input[2].value) < Number(current_day)) {
          _.confirm();
        }
        if (Number(_.Selector.year_input[2].value) >= Number(current_day)) {
          _.prohibited();
        }
        break;
      default:
        // year
        let estimated_year = Number(current_year) - Number(legal_age);
        let max_estimated_year = Number(current_year) - Number(101);

        if (
          Number(_.Selector.year_input[0].value) < Number(estimated_year) &&
          Number(_.Selector.year_input[0].value) > max_estimated_year
        ) {
          _.confirm();
        }
        if (Number(_.Selector.year_input[0].value) == Number(estimated_year)) {
          _.Selector.birth_year_title.textContent =
            _.Selector.birth_year_title.getAttribute('data-month-text');
          _.Selector.year_input[0]
            .closest('.age-gate__input')
            .classList.add('is-hide');
          _.Selector.year_input[1]
            .closest('.age-gate__input')
            .classList.remove('is-hide');
          _.Selector.year_input[1].focus();
        }
        if (Number(_.Selector.year_input[0].value) > Number(estimated_year)) {
          _.prohibited();
        }
        if (Number(_.Selector.year_input[0].value) <= max_estimated_year) {
          _.prohibited_old();
        }
    }
  };

  AgeGate.prototype.location = function () {
    var _ = this;
    fetch('/browsing_context_suggestions.json')
      .then((resp) => resp.json())
      .then(function (data) {
        _.Selector.js_age_gate_container.setAttribute(
          'data-user-country',
          data.detected_values.country_name
        );
        _.toggleMonthDay();

        var active_country =
          _.Selector.js_age_gate_container.getAttribute('data-user-country');

        active_country === 'United Kingdom'
          ? (_.Button.choose_country_strong.textContent = 'UNITED KINGDOM')
          : (_.Button.choose_country_strong.textContent = 'GLOBAL WEBSITE');

        _.Button.country_list.forEach((el) => {
          if (
            active_country === 'United Kingdom' &&
            active_country === el.getAttribute('data-country')
          ) {
            el.classList.remove('to-be-selected');
            el.classList.add('selected');
          } else if (
            active_country !== 'United Kingdom' &&
            el.getAttribute('data-country') !== 'United Kingdom'
          ) {
            el.classList.remove('to-be-selected');
            el.classList.add('selected');
          }
        });

        active_country === 'United Kingdom'
          ? document
              .querySelector('.age-gate__tcp-text.js-age-gate__tcp-text__uk')
              .classList.remove('is-hide')
          : document
              .querySelector('.age-gate__tcp-text.js-age-gate__tcp-text__row')
              .classList.remove('is-hide');
      });
  };

  AgeGate.prototype.toggleMonthDay = function () {
    var _ = this;
    var user_country = new RegExp(
      _.Selector.js_age_gate_container.getAttribute('data-user-country')
    );
    var is_us = user_country.test('United States');

    _.Selector.year_input[1]
      .closest('.age-gate__input')
      .classList.toggle('is-hide', !is_us);
    _.Selector.year_input[2]
      .closest('.age-gate__input')
      .classList.toggle('is-hide', !is_us);
    _.Selector.year_selected.classList.toggle('is-month-day-enabled', is_us);

    if (is_us) {
      _.Selector.birth_year_title.textContent =
        _.Selector.birth_year_title.getAttribute('data-birthdate-text');
    }
  };

  theme.AgeGate = new AgeGate();
};

theme.AgeGate();
